import React, { useState, useRef, useContext, useEffect, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Navigate } from 'react-router-dom';
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallback";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import  Chart  from "react-google-charts";
import AdvancedSearchContext from "context/AdvancedSearchContext";
const saveSvgAsPng = require('save-svg-as-png');

const data = [
  ["From", "To", "Kwh"],
  ["Electricité", "Eclairage", 13],
  ["Electricité", "CVC", 10],
  ["Electricité", "PC", 11],
  ["Electricité", "Autre", 8],
  ["Chaud", "CVC", 15],
  ["Froid", "CVC", 20],
  ["Froid", "Eclairage", 0],
  ["Eclairage", "Sogecap", 5],
  ["Eclairage", "CMCIC", 5],
  ["Eclairage", "SG", 3],
  ["CVC", "Sogecap", 18],
  ["CVC", "CMCIC", 19],
  ["CVC", "SG", 8],
  ["PC", "Sogecap", 7],
  ["PC", "CMCIC", 3],
  ["PC", "SG", 1],
  ["Autre", "Sogecap", 1],
  ["Autre", "CMCIC", 2],
  ["Autre", "SG", 5],
];
const options = {};

const useStyles = makeStyles(styles);

export default function TestPage() {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [redirState, setRedirState] = useState(false);



  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/testpage",
      }}
    />
  );
  //console.log(ydomain);
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"testpage"}
    >
      <GridContainer>
        <GridItem xs={12}>
          <Chart
            chartType="Sankey"
            width="100%"
            height="500px"
            data={data}
            options={options}
          />
        </GridItem>

      </GridContainer>
      {redirecting}
    </ErrorBoundary>
  );
}
